import { render, staticRenderFns } from "./MyRecords.vue?vue&type=template&id=8812bd3e&scoped=true&"
import script from "./MyRecords.vue?vue&type=script&lang=js&"
export * from "./MyRecords.vue?vue&type=script&lang=js&"
import style0 from "./MyRecords.vue?vue&type=style&index=0&id=8812bd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8812bd3e",
  null
  
)

export default component.exports